module.exports = __webpack_public_path__ + "img/advisory_solve3_icon_01.6f7aff17.png";